
<template>
  <router-link :to="`projects/${toSlug(title)}`" class="project"  >
    <div class="col text-col">
      <h2 class="detail project-title text-subtitle">{{title}}</h2>
      <!-- <h2 class="detail date text-sub-caption">{{date}}</h2> -->
      <!-- <h2 class="detail kind text-sub-caption">{{kind}}</h2> -->
      <!-- <p class="description text-short-description">{{short_description}}</p> -->
    </div>
    <div class="col image-col">
      <!-- <h2 class="detail kind text-sub-caption">{{kind}}</h2> -->
      <!-- <h2 class="detail date text-sub-caption">{{date}}</h2> -->
      <ResponsiveImage 
        v-if="coverMime === 'image'" 
        v-bind="cover_image" 
        :isResponsive="true"
        sizes="(max-width: 768) 90vw, 20vw" 
      />
      <ResponsiveVideo 
        v-else-if="coverMime === 'video'"  
        v-bind="cover_image"
        :poster="poster_image" 
        :autoplay="true" 
        :loop="true"
      />
    </div>
  </router-link>
</template>

<script>
import { slugFunctions } from '../mixins.js';
import ResponsiveImage from './ResponsiveImage.vue';
import ResponsiveVideo from './ResponsiveVideo.vue';

export default {
  name: 'ProjectRow',
  mixins: [slugFunctions],
  components: {
    ResponsiveImage,
    ResponsiveVideo
  },
  props: {
    title: {
      required: true,
      default: 'No Title',  
    },
    date: {
      required: true, 
      default: 'No Date', 
    },
    description: String,
    short_description: String,
    carousel_images: Array, 
    cover_image: Object, 
    poster_image: Object, 
    type: String, 
    kind: String, 
    role: String, 
    tags: String, 
    github_url: String,
    website_url: String,
    order: Number, 
  },
  computed: {
    coverMime() {
      let coverMime = this.cover_image && this.cover_image.mime && this.cover_image.mime.split('/')[0];
      return coverMime; 
    }
  },
}
</script>

<style lang="sass">
@import '../assets/partials/vars'

.project
  cursor: pointer
  display: block
  position: relative
  display: flex
  flex-direction: column
  margin: 0 -5%
  padding: 5%

  &:hover, &:selected
    color: $tertiary-color

  &:active, &:focus, &:focus-inside
    outline-color: $tertiary-color

  .col
    padding: 1.5rem 0

    &.text-col
      order: 0
      display: flex
      justify-content: space-between
      align-content: flex-start
      flex-wrap: wrap
      padding-bottom: 0

      .project-title
        width: 4/5 * 100vw
        margin-bottom: 12px

      .date 
        // width: 1/5 * 100%
        text-align: right

      .kind
        width: 100%

      .description
        width: 100%

+after-bg-mobile
  .project
    min-height: 30rem
    border-bottom: none
    border-right: none
    flex-direction: column
    padding: 0
    margin: 0

    &:hover
      .image-container, .video-container
        img, video
          opacity: 0.8
          transition: all 150ms cubic-bezier(0, 0.666, .333, 1) 

    .caption
      z-index: -1
      background: none

    .col
      display: flex
      flex-wrap: wrap
      padding: 0

      &.text-col
        display: flex
        flex-wrap: wrap
        // padding-right: 0

        .project-title
          width: unset
        
        .date 
          flex: 1
          margin-top: -0.1em
          margin-bottom: 3rem
          margin-left: 0.5em
          text-align: left
          display: none

        .description
          width: 100%

      &.image-col
        padding: 0 3rem 3rem 0
        padding-right: 0
        z-index: -1

        .image-container, .video-container
          width: 100%

</style>
